import React from "react"
import PropTypes from "prop-types"

import { partialStoryShape } from "app/lib/shared_prop_types"
import loadHeroImage from "shared/lib/load_hero_image"
import logIFTTTNextAction from "app/lib/ifttt_next_log_action"

import "./related_stories.scss"

class RelatedStories extends React.Component {
  handleOnClick = story => {
    logIFTTTNextAction("click", {
      location_type: "story",
      object_type: "more_content",
      object_id: story.id,
      slug: story.slug,
    })
  }

  render() {
    return (
      <>
        <h3>You may also like</h3>
        <section styleName="related-content">
          {this.props.relatedStories.map(story => (
            <a
              key={story.slug}
              href={`${this.props.storyPath}${story.slug}`}
              rel="noreferrer"
              styleName="story-card"
              onClick={() => this.handleOnClick(story)}
            >
              <div
                styleName="hero"
                title={story.title}
                aria-label={story.title}
                style={{
                  background: `linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(0,0,0,0) 66%, rgba(0, 0, 0, 0.6)), url(${loadHeroImage(
                    story.hero_image
                  )})`,
                  backgroundSize: "auto 10em",
                  backgroundPosition: "center",
                  backgroundColor: `${story.hero_image["background_color"]}`,
                }}
              />
              <div styleName="title">
                <h5>{story.title}</h5>
              </div>
            </a>
          ))}
        </section>
      </>
    )
  }
}

RelatedStories.propTypes = {
  relatedStories: PropTypes.arrayOf(partialStoryShape),
  storyPath: PropTypes.string.isRequired,
}

export default RelatedStories
